export const renderDate = function (dateTime) {
  return new Date(dateTime).toLocaleDateString("en-In");
};

export const formatMomentDate = function (dateTime) {
  if (dateTime?._isAMomentObject && dateTime?._isValid) {
    return new Date(dateTime.toDate()).toLocaleDateString("en-Gb");
  } else {
    return dateTime;
  }
};
